import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetDeviceMatrixByFormId(formId) {
  const response = await $.soap({
    body: {
      GetDeviceMatrixByFormId: {
        $xmlns: 'http://dla.mil/ems/db/order/device_matrix',
        FormId: formId
      }
    },
    blueprintArrays: ['GetDeviceMatrixByFormIdResponse'],
    blueprint: {
      deviceMatrix: [
        '$..tuple',
        {
          id: '$..ID',
          formTypeId: '$..FormID',
          description: '$..Description',
          isPrinterNIPR: '$..IsPrinterNIPR',
          isPrinterSIPR: '$..IsPrinterSIPR',
          isMFDNIPR: '$..IsMFDNIPR',
          isMFDSIPR: '$..IsMFDSIPR',
          isScanner: '$..IsScanner'
        }
      ]
    }
  });

  cleanUpResponse(response);
  return response.deviceMatrix;
}
